{
  "BUSINESS_NUMBER": {
    "TITLE": "Introduïu el vostre número d'expedient per començar",
    "INSTRUCTION_FORMAT": "Format: 7 dígits com a mínim.",
    "PLACEHOLDER": "Ex.: 1234567",
    "ERROR_INVALID_FORMAT": "El número d'expedient ha de contenir almenys 7 dígits."
  },
  "BUTTON": {
    "VALIDATE": "Validar",
    "VALIDATE_MY_CHOICES": "Validar les meves eleccions"
  },
  "CONFIRM_DIALOG": {
    "VALIDATE": "Validar",
    "CANCEL": "Abandonar"
  },
  "FOOTER": {
    "COPYRIGHT_NOTICE": "© {{ year }} EVOQ {{ brandLabel }}. Tots els drets reservats."
  },
  "FREE_ROAM": {
    "CREATIVE_SUGGESTION": "Per modificar la teva escena 3D i obtenir una imatge ultrarealista, podries considerar afegir elements específics com ara: una estança annexa, un estil, elements de decoració, un moment del dia... Deixa volar la teva creativitat!",
    "TYPE_TEXT_HERE": "Escriu el teu text aquí (mínim 100 caràcters)",
    "VISUAL_IMPROVEMENT_DESCRIPTION": "Si us plau, descriu les millores que vols aportar a la teva imatge"
  },
  "GENERATION_RESULT": {
    "COPIED_CONFIRMATION": "Copiat!",
    "COPY_PROMPT": "Copia el prompt",
    "ENLARGE_IMAGE": "Ampliar",
    "DOWNLOAD_IMAGE": "Descarrega la imatge",
    "DOWNLOAD_VIDEO": "Descarrega el vídeo",
    "EDIT_PROMPT": "Edita el prompt",
    "EVOQ_PROPOSED_VISUAL": "Aquí tens la imatge proposada per Evoq",
    "EVOQ_PROPOSED_VISUALS": "Aquí tens les imatges proposades per Evoq",
    "GENERATE_VIDEO": "Genera el vídeo",
    "GENERATION_ERROR_RETRY": "S'ha produït un error durant la generació. Si us plau, torna-ho a provar.",
    "SERVER_BUSY_ERROR": "Els nostres servidors estan molt ocupats en aquest moment. Si us plau, torneu-ho a provar d'aquí a uns instants.",
    "RETRY_ACTION": "Tornar a provar",
    "PROCESSING_VIDEOS_COUNT": "{{ processingVideoCount }} vídeos en curs",
    "REGENERATE_ACTION": "Regenerar",
    "REMAINING_IMAGES": "Imatges restants:",
    "REMAINING_VIDEOS": "Vídeos restants:",
    "VIDEO_CREATION_IN_PROGRESS": "Vídeo en procés de creació",
    "WAIT_MOMENT_MESSAGE": "Si us plau, espera un moment..."
  },
  "GUIDED_TOUR": {
    "ANSWER": {
      "ROOM_BATHROOM": "Bany",
      "ROOM_BEDROOM": "Dormitori",
      "ROOM_DINING": "Menjador",
      "ROOM_DRESSING": "Vestidor",
      "ROOM_ENTRANCE": "Rebedor",
      "ROOM_KITCHEN": "Cuina",
      "ROOM_LAUNDRY": "Safareig",
      "ROOM_LIVING": "Sala d'estar",
      "ROOM_NO": "No",
      "ROOM_OFFICE": "Despatx",
      "ROOM_PANTRY": "Rebost",
      "STYLE_CONTEMPORARY": "Contemporani",
      "STYLE_COUNTRY": "Campestre",
      "STYLE_COZY": "Acollidor",
      "STYLE_DESIGN": "Disseny",
      "STYLE_HIGH_END": "Alta gamma",
      "STYLE_INDUSTRIAL": "Industrial",
      "STYLE_MODERN": "Modern",
      "STYLE_RUSTIC": "Rústic",
      "STYLE_SCANDINAVIAN": "Escandinau",
      "STYLE_WOOD": "Fusta",
      "TIME_AFTERNOON": "A la tarda",
      "TIME_EVENING": "Al vespre",
      "TIME_MORNING": "Al matí",
      "TIME_NONE": "Cap",
      "TIME_NOON": "Al migdia"
    },
    "FORM": {
      "ENTER_ELEMENT": "Introdueix un element"
    },
    "QUESTION": {
      "ADJOINING_ROOM": "Vols incloure una estança annexa al teu plànol principal?",
      "APPLY_STYLE": "Quin estil vols aplicar a la teva escena?",
      "DECORATION_ELEMENTS": "Quins elements essencials de decoració vols afegir?",
      "MAIN_ROOM_SELECTION": "Quina és l'estança principal que vols tractar?",
      "TIME_OF_DAY": "A quin moment del dia vols fer referència?"
    }
  },
  "HEADER": {
    "BUDGET_THIS_MONTH": "Pressupost consumit aquest mes (estimació)",
    "DASHBOARD": "Tauler de control",
    "FREE_CREDITS": "Crèdits gratuïts",
    "FREE_CREDITS_LABEL": "crèdits gratuïts",
    "IMAGES_THIS_MONTH": "Imatges generades aquest mes",
    "LOGOUT": "Tancar sessió",
    "NEW_PROJECT": "Nou projecte",
    "THIS_MONTH": "Aquest mes",
    "VIDEOS_THIS_MONTH": "Vídeos generats aquest mes"
  },
  "IMAGE_UPLOAD": {
    "ACCEPTED_FORMATS": "Formats acceptats: PNG o JPEG.",
    "ALL_CREDITS_USED": "Has utilitzat tots els teus crèdits",
    "BLOCKED_GENERIC": "La generació d'imatges no està disponible temporalment.",
    "BLOCKED_NO_QUOTA": "No hi ha cap quota d'Evoq definida per al teu compte.",
    "BLOCKED_QUOTA_MONTHLY": "Has esgotat la teva quota mensual d'Evoq. Posa't en contacte amb el teu responsable.",
    "BLOCKED_QUOTA_ROLLING": "Has esgotat la teva quota d'Evoq.",
    "BLOCKED_QUOTA_ROLLING_UNTIL": "Has esgotat la teva quota d'Evoq. Podràs generar de nou el {{ date }}.",
    "BLOCKED_UNAVAILABLE": "No disponible",
    "CATALOG_ONLY_NOTICE": "Nota: Tot element present a la teva escena no serà transformat per la IA sinó millorat per obtenir un resultat realista.",
    "FILE_SIZE_LIMIT": "La mida del fitxer no ha de superar els {{ size }} MB",
    "FREE_IMAGE_GENERATION": "Generació d'imatge lliure",
    "GUIDED_IMAGE_GENERATION": "Generació d'imatge guiada",
    "IMPORT_ROOM_VISUAL": "Importa la teva imatge",
    "INSUFFICIENT_DIMENSIONS": "Dimensions insuficients (mín. {{ minWidth }} x {{ minHeight }} px)",
    "INVALID_FORMAT": "Format incorrecte (només PNG o JPEG)",
    "LIGHTING_WARNING": "<strong>Important:</strong> utilitzeu un plànol sense efectes d'il·luminació per evitar qualsevol al·lucinació de la IA.",
    "MINIMUM_IMAGE_DIMENSIONS": "Dimensions mínimes de la imatge per pujar: {{ minWidth }} x {{ minHeight }} píxels.",
    "NO_MORE_CREDIT": "Sense crèdits",
    "UNREADABLE_FILE": "No es pot llegir el fitxer",
    "UPLOAD_ROOM_VISUAL": "Carrega la imatge del teu espai per començar"
  },
  "LOGIN": {
    "AUTHENTICATING_MESSAGE": "Si us plau, espera mentre recuperem la teva informació...",
    "AUTHENTICATING_TITLE": "Autenticació en curs",
    "AUTO_LOGIN_FOURNIER": "Connexió automàtica Fournier",
    "AUTO_LOGIN_FRANCHISEE": "Connexió automàtica Franquiciat",
    "CHOOSE_SPACE_INSTRUCTION": "Tria el teu espai per continuar",
    "ERROR_FRANCHISE_MISSING_STORE_MESSAGE": "El vostre compte no està vinculat a cap botiga. Si us plau, creeu un Ticket Easy Vista per completar aquesta informació i torneu-ho a provar.",
    "ERROR_FRANCHISE_MISSING_STORE_TITLE": "Connexió impossible",
    "ERROR_MESSAGE": "S'ha produït un error en recuperar la teva informació. Si us plau, torna-ho a provar.",
    "ERROR_TITLE": "Error d'autenticació",
    "RETRY_BUTTON": "Tornar a provar",
    "WELCOME_MESSAGE": "Benvingut a Evoq"
  },
  "DASHBOARD": {
    "TITLE": "Tauler de control",
    "NAV": {
      "OVERVIEW": "Resum",
      "VENDORS": "Equip",
      "BILLING_HISTORY": "Historial de facturació"
    },
    "OVERVIEW": {
      "TITLE": "Resum",
      "MANAGE": "Gestionar",
      "PLACEHOLDER": {
        "TITLE": "Ben aviat",
        "DESCRIPTION": "La visió general de la vostra activitat s'està renovant."
      }
    },
    "VENDORS": {
      "TITLE": "Gestió de l'equip",
      "PHYSICAL": {
        "SUBTITLE": "Activeu o doneu de baixa la subscripció de cada venedor del vostre equip.",
        "COUNTER_ACTIVE": "Subscrits actius",
        "COUNTER_NONE": "Sense subscripció",
        "COUNTER_CANCELLING": "Baixa programada",
        "TABLE_TITLE": "Venedors",
        "COST_HINT": "Cost de la subscripció: {{price}} / mes / venedor",
        "COST_UNAVAILABLE": "Tarifes no disponibles",
        "COL_VENDOR": "Venedor",
        "COL_STATUS": "Estat",
        "COL_ACTION": "Acció",
        "SELECT_ALL": "Selecciona-ho tot",
        "SELECT_ROW": "Selecciona {{name}}",
        "SELECT_ROW_DISABLED": "{{name}} no es pot seleccionar",
        "STATUS_SUBSCRIBED": "Subscrit",
        "STATUS_NONE": "Sense subscripció",
        "STATUS_CANCELLING": "Baixa programada",
        "CANCELLING_EFFECT": "Efectiu el {{date}}",
        "FREE_CREDITS": "Crèdits gratuïts: {{count}} / {{total}} restants",
        "ACTION_ACTIVATE": "Activar la subscripció",
        "ACTION_CANCEL": "Donar de baixa",
        "ACTION_REACTIVATE": "Anul·lar la baixa",
        "SELECTED_ONE": "venedor seleccionat",
        "SELECTED_OTHER": "venedors seleccionats",
        "BULK_ACTIVATE": "Activar la subscripció",
        "BULK_CLEAR": "Desselecciona-ho tot",
        "EMPTY": "No hi ha venedors en aquest equip.",
        "LOADING": "S'està carregant...",
        "ENGAGEMENT_NOTE": "Subscripció compromesa fins al final del trimestre natural, renovada automàticament cada trimestre tret de baixa; aquesta té efecte al final del trimestre.",
        "CONFIRM_ACTIVATE_TITLE": "Activar la subscripció",
        "CONFIRM_ACTIVATE_BODY": "{{name}}, {{price}} / mes. Subscripció compromesa fins al final del trimestre natural, després renovada automàticament cada trimestre tret de baixa.",
        "CONFIRM_ACTIVATE_OK": "Activar",
        "DESK_REQUEST_TITLE": "Per activar una subscripció, obre una sol·licitud mitjançant un tiquet Desk",
        "DESK_REQUEST_PATH": "Desk → Crear un tiquet Desk Fournier Retail, Secció \"Service\"",
        "DESK_CLOSE": "Tancar",
        "CANCEL": "Cancel·la",
        "CONFIRM_CANCEL_TITLE": "Donar de baixa la subscripció",
        "CONFIRM_CANCEL_BODY": "Efectiu el {{date}} (final del trimestre en curs). {{name}} conserva l'accés fins llavors.",
        "CONFIRM_CANCEL_OK": "Donar de baixa",
        "CONFIRM_REACTIVATE_TITLE": "Anul·lar la baixa",
        "CONFIRM_REACTIVATE_BODY": "La subscripció de {{name}} continuarà amb normalitat.",
        "CONFIRM_REACTIVATE_OK": "Confirmar",
        "CONFIRM_REACTIVATE_BACK": "Enrere",
        "BULK_CONFIRM": "Confirmar l'activació",
        "BULK_UNIT_COST": "Cost unitari",
        "BULK_ENGAGEMENT": "Compromís",
        "BULK_ENGAGEMENT_VALUE": "Fins al final del trimestre",
        "BULK_TOTAL": "Total mensual",
        "TOAST_ACTIVATED": "Subscripció activada per a {{name}}",
        "TOAST_CANCELLED": "Baixa programada per a {{name}}",
        "TOAST_REACTIVATED": "Baixa anul·lada per a {{name}}",
        "TOAST_BULK_ONE": "Subscripció activada per a 1 venedor",
        "TOAST_BULK_OTHER": "Subscripció activada per a {{count}} venedors",
        "TOAST_ERROR": "S'ha produït un error, torneu-ho a provar."
      }
    },
    "BILLING_HISTORY": {
      "TITLE": "Historial de facturació",
      "BADGE": "subscripcions",
      "INTRO": "Facturació de les subscripcions del teu equip, facturada mensualment i agrupada per trimestre. Per a cada mes: el nombre de subscripcions actives i el cost corresponent.",
      "KPI_TOTAL_YEAR": "Total {{ year }}",
      "KPI_TOTAL_YEAR_TO_DATE": "Total {{ year }} fins ara",
      "KPI_CURRENT_QUARTER": "Trimestre en curs",
      "KPI_LAST_QUARTER": "Últim trimestre",
      "CARD_TITLE": "Facturació mensual",
      "YEAR_SELECTOR_LABEL": "Selecció de l'any",
      "STATUS_IN_PROGRESS": "Trimestre en curs",
      "STATUS_CHARGED": "Facturat",
      "SUBTOTAL": "Subtotal",
      "TOTAL": "Total",
      "NOTE": "Factura mensual, emesa pel mes transcorregut i agrupada per trimestre natural (T1 gen.-març, T2 abr.-juny, T3 jul.-set., T4 oct.-des.). Tota subscripció activa durant el mes es factura pel mes complet, sense prorrateig. La tarifa i el cost mensual els proporciona la facturació."
    },
    "CONSUMPTION": {
      "TITLE": "Consum de l'equip",
      "VENDOR": "Membre",
      "IMAGE": "Imatge",
      "VIDEO": "Vídeo",
      "REMAINING": "Resta: {{ value }}",
      "REMAINING_WITH_FREE": "Resta: {{ total }} dels quals {{ free }} gratuïts",
      "NO_VENDORS": "Cap membre per ara"
    },
    "ALLOCATION": {
      "CANNOT_GENERATE": "No pot generar",
      "QUOTA_HIDDEN_NOTICE": "La quota la defineix aquí el responsable. Per a l'usuari resta invisible: el venedor només veu el seu consum i el seu pressupost.",
      "IMAGE_QUOTA": "Quota Imatge",
      "VIDEO_QUOTA": "Quota Vídeo",
      "APPLY": "Aplicar",
      "SAVING": "Desant...",
      "SAVE_QUOTAS": "Desar les quotes",
      "SAVE_SUCCESS": "Les quotes s'han actualitzat correctament",
      "IMAGE": "Imatge",
      "VIDEO": "Vídeo",
      "CONSUMPTION": "Consum",
      "MONTHLY_QUOTA": "Quota Mensual",
      "FREE_CREDITS": "Gratuïts",
      "REMAINING": "Resta: {{ value }}"
    },
    "PACKS": {
      "FILTER_ALL": "Tots",
      "FILTER_IMAGES": "Imatges",
      "FILTER_VIDEOS": "Vídeos",
      "FILTER_MIXED": "Mixtos",
      "PRICE_PER_IMAGE": "És a dir {{ price }} per imatge",
      "PRICE_PER_VIDEO": "És a dir {{ price }} per vídeo",
      "CREDITS": "Crèdits",
      "IMAGES": "Imatges",
      "VIDEO": "Vídeo",
      "CHOOSE_PACK": "Triar aquest pack"
    },
    "BILLING_HISTORY_TABLE": {
      "MONTH": "Mes",
      "ACTIVE_SUBSCRIPTIONS": "Subscripcions actives",
      "MONTHLY_COST": "Cost mensual",
      "EMPTY_TITLE": "Sense facturació",
      "EMPTY_MESSAGE": "L'historial de facturació de les teves subscripcions apareixerà aquí."
    },
    "USAGE_HISTORY": {
      "BADGE": "per usuari",
      "INTRO": "Consum mensual per usuari i cost corresponent.",
      "KPI_TOTAL_MONTH": "Total",
      "KPI_LAST_3_MONTHS": "Últims 3 mesos",
      "NOTE": "Consum facturat per trimestre (mes en curs i els dos anteriors). El cost de cada mes es fixa en el moment del consum."
    },
    "USAGE_HISTORY_TABLE": {
      "CARD_TITLE": "Detall per usuari",
      "USER": "Usuari",
      "IMAGES": "Imatges",
      "VIDEOS": "Vídeos",
      "COST": "Cost",
      "MONTH_SELECTOR_LABEL": "Selecció de mes",
      "TOTAL": "Total",
      "EMPTY_TITLE": "Sense consum",
      "EMPTY_MESSAGE": "L'historial de consum del vostre equip apareixerà aquí."
    }
  },
  "STORE_SELECTION": {
    "TITLE": "Seleccioneu la vostra botiga",
    "SUBTITLE": "Trieu la botiga que voleu gestionar",
    "SEARCH_PLACEHOLDER": "Cercar per nom, ID, marca…",
    "SEARCH_SHORT": "Cercar…",
    "ALL_BRANDS": "Totes les marques",
    "ALL_TYPES": "Tots els tipus",
    "RESULTS": "resultats",
    "STORES_LINKED": "botigues vinculades al vostre compte",
    "NO_RESULTS": "No s'han trobat botigues",
    "SEE_ALL": "Veure totes les botigues",
    "SWITCH_STORE": "Canviar de botiga",
    "TYPE": {
      "PHYSICAL": "Física",
      "VIRTUAL": "Virtual"
    },
    "TABLE": {
      "STORE": "Botiga",
      "STORE_ID": "ID Botiga",
      "BRAND": "Marca",
      "TYPE": "Tipus",
      "ACTION": "Acció",
      "SELECT_STORE": "Seleccionar {{ name }}"
    }
  }
}
